import AuthService from './authService.js';

class PlanningAssignmentService {
  static async SetItemAssignment(pricingIds, schedulerUserId, accountManagerUserId) {
    const data = { pricingIds, schedulerUserId, accountManagerUserId };
    return AuthService.getInstance().CallBackendFunctionPut('api/PlanningAssignment/SetItemAssignment', data);
  }

  static async SetServiceAccountManager(serviceId, accountManagerUserId, applyToAllCountries, countryIds) {
    // Bool select inputs emit the string 'true'/'false'; coerce to a real boolean so the
    // backend's System.Text.Json bool binding accepts it (string -> bool throws, unlike string -> int).
    const data = {
      serviceId,
      accountManagerUserId,
      applyToAllCountries: applyToAllCountries === true || applyToAllCountries === 'true',
      countryIds: (countryIds || []).map(Number),
    };
    return AuthService.getInstance().CallBackendFunctionPut('api/PlanningAssignment/SetServiceAccountManager', data);
  }

  static async GetServiceCountries(serviceId) {
    return AuthService.getInstance().CallBackendFunction(`api/PlanningAssignment/GetServiceCountries/${serviceId}`);
  }

  static async SetCountryDefaultScheduler(countryId, defaultSchedulerUserId) {
    const data = { countryId, defaultSchedulerUserId };
    return AuthService.getInstance().CallBackendFunctionPut('api/PlanningAssignment/SetCountryDefaultScheduler', data);
  }

  static async DownloadAssignmentTemplate(serviceId) {
    return AuthService.getInstance().CallBackendFunctionGetFile(
      `api/PlanningAssignment/DownloadAssignmentTemplate/${serviceId}`
    );
  }

  // True while a temp-table rebuild this user asked for is still queued or running. An assignment
  // save returns as soon as it is written, but the grid reads the temp tables — so the list page
  // polls this and reloads itself once the rebuild has landed, instead of leaving the user to work
  // out that a manual Refresh is needed.
  // clearCache is explicit rather than left to CallBackendFunction's fallback: the whole point of
  // the call is to see the answer change, and a cached "still pending" would strand the page.
  static async IsRefreshPending() {
    return AuthService.getInstance().CallBackendFunction('api/PlanningAssignment/IsRefreshPending?clearCache=true');
  }

  static async UploadAssignments(file) {
    const formData = new FormData();
    formData.append('file', file);
    return AuthService.getInstance().CallBackendFunctionPostFile('api/PlanningAssignment/UploadAssignments', formData);
  }
}

export default PlanningAssignmentService;
